<template>
  <v-flex>
    <v-row
        v-if="getCost() != null"
        align="start"
    >
      <v-flex
          shrink
          pr-2
          pt-2
      >
        <BookingAdditionalChargeSummary
            :booking="bookingForm.booking"
            @getCostEstimate="getCostEstimate"
        />
      </v-flex>
      <v-flex
          v-if="fixedCost() != null"
          shrink
          pt-2
          style="padding-right: 3px"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon
                color="primary"
                dark
                v-on="on"
            >
              info
            </v-icon>
          </template>
          <p style="font-size: 12px">
            {{ fixedCost() }}
          </p>
        </v-tooltip>
      </v-flex>
      <v-flex
          pt-2
          shrink
      >
        <v-col>
          <p
              v-if="bookingForm.booking.final_fare != null"
              class="cost-amount"
          >
            Fare £{{ bookingForm.booking.final_fare }}
          </p>
          <v-row>
            <p
                v-if="getCost() != null"
                class="cost-amount"
                :style="{'color': bookingForm.booking.final_fare != null ? 'grey' : 'black'}"
            >
              Est £{{ (getCost() / 100).toFixed(2) }}
            </p>
            <p
                v-if="getCostPromotion() != null"
                :style="{'color': bookingForm.booking.final_fare != null ? 'grey' : 'black'}"
                class="cost-amount"
            >
              &nbsp;→&nbsp;£{{ (getCostPromotion() / 100).toFixed(2) }}
            </p>
          </v-row>
        </v-col>
      </v-flex>
      <v-flex
          v-if="bookingForm.booking.finalFareMode == true"
          pt-2
          :style="styleForCostBox"
      >
        <v-col>
<!--
          <v-flex
              v-if="finalCostIncludingAdditionals() != null"
              shrink
              style="padding-right: 3px"
          >
            <p class="cost-amount">
              &nbsp;&nbsp;Final Cost £{{ finalCostIncludingAdditionals() }}
            </p>
          </v-flex>
-->
          <v-flex
              v-if="finalCostIncludingAdditionals() != null"
              shrink
              style="padding-right: 3px"
          >
            <p class="cost-amount">
              &nbsp;&nbsp;Final Cost £{{ finalCostIncludingAdditionals() }}
            </p>
          </v-flex>
          <v-flex
              v-if="bookingForm.booking.state != null && bookingForm.booking.final_cost > 0 && bookingForm.booking.final_cost != finalCostIncludingAdditionals()"
              shrink
              style="padding-right: 3px"
          >
            <p class="cost-amount">
              &nbsp;&nbsp;Old Final Cost £{{ bookingForm.booking.final_cost }}
            </p>
          </v-flex>
          <v-flex>
            <p
                v-if="bookingForm.booking.final_cost_promotion"
                class="cost-amount"
            >
              Final Cost Promotion<br>£{{ (bookingForm.booking.final_cost_promotion.toFixed(2)) }}
            </p>
          </v-flex>
          <v-flex
              v-if="costOfAdditionals() != null && costOfAdditionals() != 0"
              style="padding-right: 3px"
          >
            <p class="cost-amount">
              &nbsp;&nbsp;Additionals £{{ costOfAdditionals() }}
            </p>
          </v-flex>
          <v-flex
            px-1
          >
            <p
              v-if="finalCostIncludingAdditionalsAndPromoCode()"
              class="mrc-text-12-bold"
            >
                  <span class="cmr-label-text">
                    Customer Pays
                  </span>
              <span class="mrc-metallic-green" :class="{ 'fare-strike-through': bookingForm.booking.promocode}">£{{ finalCostIncludingAdditionalsForCustomer() }}</span>
              <span class="mrc-metallic-green" v-if="bookingForm.booking.promocode">
                    <v-icon small>mdi-arrow-right</v-icon>
                    £{{ finalCostIncludingAdditionalsAndPromoCode() }}
                  </span>
            </p>
          </v-flex>
  
          <v-flex
              v-if="bookingIsCompletedOrCancelled && bookingForm.booking.fixed_commission != null"
              style="padding-right: 3px"
          >
            <p class="cost-amount">
              &nbsp;&nbsp;Fixed Commission £{{ bookingForm.booking.fixed_commission }}
            </p>
          </v-flex>
        </v-col>
      </v-flex>
      <v-flex class="mt-2" v-if="isReturnBooking && showFareWarning">
        <v-chip close @click:close="showFareWarning = false" color="red" class="white--text">
          Please note that this fare may not be accurate as its not system generated
        </v-chip>
      </v-flex>
    </v-row>
  </v-flex>
</template>

<script>

import BookingAdditionalChargeSummary from "@/components/widget/input/BookingAdditionalChargeSummary.vue";

export default {
  name: "EstimatedCost",
  components: {
    BookingAdditionalChargeSummary
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    bookingForm: Object,
  },
  data() {
    return {
      showFareWarning: true,
    };
  },
  computed: {
    isReturnBooking () {
      return this.$store.getters['booking/getIsReturnBooking']
    },
    styleForFinalCostBox: function () {
      return {
        "background-color": "#FFB6C1",
      };
    },
  },
  methods: {
    styleForCostBox () {
    console.log('implement it')
    },
    finalCostIncludingAdditionalsAndPromoCode: function () {
      var additionalCharges = 0;
    
      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }
      let promocodeAmount = 0;
      if (this.getCostPromotion()) {
        promocodeAmount = this.getCostPromotion()
      }
      console.log("Promo code amount", promocodeAmount)
      
      // return ((promocodeAmount + additionalCharges) /100).toFixed(2);
      return ((promocodeAmount ) /100).toFixed(2);
  /*    if (this.bookingForm.booking.final_fare != 0) {
        var finalFare = this.bookingForm.booking.final_fare;
        console.log("final fare",  finalFare)
        if (finalFare != 0 && finalFare != null) {
          return (((finalFare) + additionalCharges / 100) - (promocodeAmount != null ? promocodeAmount /100 : 0)).toFixed(2);
        } else {
          if (this.getCost()) {
            return ((this.getCost()/100 + additionalCharges / 100) - (promocodeAmount != null ? promocodeAmount/100 : 0)).toFixed(2);
          }
        }
      } else {
        return null;
      }*/
    },
    bookingIsCompletedOrCancelled() {
      return (
          this.bookingForm.booking.state == "completed" ||
          this.bookingForm.booking.state == "cancelled"
      );
    },
    getCostEstimate: function() {
      this.$emit("getCostEstimate")
    },
    getCostObject: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        return costForRideType;
      }
    },
    getCost: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
        if (costForRideType != null) {
          return costForRideType.estimate;
        } else {
          return null;
        }
      }
    },
    getCostPromotion: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        if (costForRideType != null) {
          return costForRideType.estimate_promotion;
        } else {
          return null;
        }
      }
    },
    fixedCost: function () {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function (cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        if (costForRideType != null) {
          return costForRideType.fixed_cost;
        } else {
          return null;
        }
      }
    },
    finalCostIncludingAdditionalsForCustomer: function () {
      var additionalCharges = 0;
    
      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }
      if (this.bookingForm.booking.final_fare != 0) {
        var finalFare = this.bookingForm.booking.final_fare;
        console.log("final fare",  finalFare)
        if (finalFare != 0 && finalFare != null) {
          return (((finalFare) + additionalCharges / 100)).toFixed(2);
        } else {
          if (this.getCost()) {
            // return ((this.getCost()/100 + additionalCharges / 100)).toFixed(2);
            return ((this.getCost()/100)).toFixed(2);
          }
        }
      } else {
        return null;
      }
    },
    finalCostIncludingAdditionals: function () {
      if (this.bookingForm.booking.final_fare != 0 && this.bookingForm.booking.final_fare != null && this.bookingForm.booking.fixed_cost == true) {

        var finalFare = this.bookingForm.booking.final_fare;
        var additionalCharges = 0;

        for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
          if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
            additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
          }
        }

        return ((finalFare) + additionalCharges / 100).toFixed(2);

      } else {
        return null;
      }
    },
    costOfAdditionals: function () {
      var additionalCharges = 0;

      for (var i = 0; i < this.bookingForm.booking.bookingAdditionalCharges.length; i++) {
        if ( this.bookingForm.booking.bookingAdditionalCharges[i].enabled == true) {
          additionalCharges += this.bookingForm.booking.bookingAdditionalCharges[i].amount;
        }
      }

      return (additionalCharges / 100).toFixed(2);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.cost-amount {
  font-size: 12px;
  font-weight: 500;
}

.est-text {
  font-size: 12px;
  font-weight: 700;
}
</style>
